import { getCartRefresh } from 'shared/api/cart';
import {
  getCartQuantityAdjustmentBlocker,
  setPendingPostLoginOverQtyNudge,
  setPendingPostLoginPartialOOS,
} from 'shared/helpers/cartQuantityAdjustmentBlockers';
import { getStore } from 'shared/store';

const navigate = (url: string, isIframe: boolean) => {
  if (isIframe) {
    window.parent.location.href = url;
  } else {
    window.location.href = url;
  }
};

const fetchCartForPostLoginBlocker = async (isOverQuantityNudgeEnabled: boolean) => {
  const { cart } = await getCartRefresh({ shouldSendPincode: false });
  return getCartQuantityAdjustmentBlocker(cart, isOverQuantityNudgeEnabled);
};

export const redirectAfterLogin = (redirectURL: string, isIframe = false) => {
  const state = getStore()?.getState() || {};
  const isOverQuantityNudgeEnabled = Boolean(state.remoteConfigs?.isOverQuantityNudgeEnabled);

  fetchCartForPostLoginBlocker(isOverQuantityNudgeEnabled)
    .then((blocker) => {
      if (blocker === 'partialOOS') {
        setPendingPostLoginPartialOOS();
        window.location.reload();
        return;
      }

      if (blocker === 'overQuantity') {
        setPendingPostLoginOverQtyNudge();
        window.location.reload();
        return;
      }

      navigate(redirectURL, isIframe);
    })
    .catch(() => {
      navigate(redirectURL, isIframe);
    });
};


export {
  clearPendingPostLoginOverQtyNudge,
  clearPendingPostLoginPartialOOS,
  hasPendingPostLoginOverQtyNudge,
  hasPendingPostLoginPartialOOS,
  setPendingPostLoginOverQtyNudge,
  setPendingPostLoginPartialOOS,
} from 'shared/helpers/cartQuantityAdjustmentBlockers';
